import { MouseEventHandler } from 'react'
import { ToastOptions } from 'react-toastify'
import { pluralize } from '@opallabs/lambda'
import { ActionToast, type ToastComponent } from '@opallabs/lapidary'

export const defaultAddToPlanFailureOptions: ToastOptions = {
  toastId: 'add-to-plan-failure',
  type: 'error',
  closeOnClick: true,
}

type FailedToastProps = {
  errorMessage?: string
  momentCount: number
  planTitle: string
  onActionClick?: MouseEventHandler<HTMLButtonElement>
}

export const AddToPlanFailureToast: ToastComponent<FailedToastProps> = ({
  errorMessage = '',
  momentCount,
  onActionClick,
  planTitle,
  ...toastProps
}) => {
  return (
    <ActionToast
      {...toastProps}
      actionText="Show Failed Items"
      onActionClick={onActionClick}
      message={
        <>
          {`${momentCount} ${pluralize('moment', momentCount)} failed to be added to the plan "${planTitle}". ${errorMessage}`}
        </>
      }
      title={`${pluralize('Moment', momentCount)} could not be added to plan`}
    />
  )
}
